// tslint:disable
/* MACLE TypeScript 17/07/2025 17:31:44 */
import { DataPagamentoPIXAPP, PKPagamentoPIXAPP } from '../vo/sitevo.vo';
import { BaseVO } from '../vo/maf.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class PagamentoPIXModelService extends BaseService {
  private _url = 'pagamentopixService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public add(vo: DataPagamentoPIXAPP): Promise<PKPagamentoPIXAPP> {
    let params = {
      "vo": vo
    };
    return this.ajax.post(this._url + 'add', params)
      .then((r: IModelServiceResponse<PKPagamentoPIXAPP>) => Parser.jsonToClass(r.value, PKPagamentoPIXAPP))
      .catch((error: any) => this.handleError(error));
  }

  public exists(pk: PKPagamentoPIXAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'exists', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getPage(PageIdx: number, NumRecInPage: number): Promise<DataPagamentoPIXAPP[]> {
    let params = {
      "PageIdx": PageIdx,
      "NumRecInPage": NumRecInPage
    };
    return this.ajax.post(this._url + 'getPage', params)
      .then((r: IModelServiceResponse<ArrayList<DataPagamentoPIXAPP>>) => Parser.jsonToClass(r.value, DataPagamentoPIXAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getCount(): Promise<number> {
    return this.ajax.get(this._url + 'getCount')
      .then((r: IModelServiceResponse<number>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getData(pk: PKPagamentoPIXAPP): Promise<DataPagamentoPIXAPP> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'getData', params)
      .then((r: IModelServiceResponse<DataPagamentoPIXAPP>) => Parser.jsonToClass(r.value, DataPagamentoPIXAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getList(filter: BaseVO): Promise<DataPagamentoPIXAPP[]> {
    let params = {
      "filter": filter
    };
    return this.ajax.post(this._url + 'getList', params)
      .then((r: IModelServiceResponse<ArrayList<DataPagamentoPIXAPP>>) => Parser.jsonToClass(r.value, DataPagamentoPIXAPP))
      .catch((error: any) => this.handleError(error));
  }

  public del(pk: PKPagamentoPIXAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'del', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

  public isPixPago(pk: PKPagamentoPIXAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'isPixPago', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public liquidaPagamentoPIX(pk: PKPagamentoPIXAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'liquidaPagamentoPIX', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

}


